import http from '@/utils/http'

//功能集列表

export function getModuleList(params) {
    return http({
      method: 'get',
      url: '/system/sysModuleCollection/paging',
      params
    })
  }

//获取所有功能模块
export function getModule() {
  return http({
    method: 'get',
    url: '/system/sysModule/list'
  })
}

//获取功能集详情
export function getModuleDetail(params) {
  return http({
    method: 'get',
    url: '/system/sysModuleCollection/find',
    params
  })
}

//添加一份功能集
export function postModuleData(data) {
  return http({
    method: 'post',
    url: '/system/sysModuleCollection/add',
    data:data
  })
}

//编辑功能集
export function editModuleData(data) {
  return http({
    method: 'post',
    url: '/system/sysModuleCollection/update',
    data:data
  })
}

//获取功能集列表(不分页, 不搜索)
export function getFunctionList() {
  return http({
    method: 'get',
    url: '/system/sysModuleCollection/list',
  })
}

//批量配置功能集
export function batchModule(data) {
  return http({
    method: 'post',
    url: '/system/xcwsEntity/school/collection/batchUpdate',
    data:data
  })
}